import { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';

export default function InstallAppButton() {
  const [promptEvent, setPromptEvent] = useState(null);
  const [installed, setInstalled] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    const standalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    setInstalled(standalone);

    const handlePrompt = (event) => {
      event.preventDefault();
      setPromptEvent(event);
    };
    const handleInstalled = () => setInstalled(true);

    window.addEventListener('beforeinstallprompt', handlePrompt);
    window.addEventListener('appinstalled', handleInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', handlePrompt);
      window.removeEventListener('appinstalled', handleInstalled);
    };
  }, []);

  const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);

  if (installed) return null;

  const handleClick = async () => {
    if (promptEvent) {
      promptEvent.prompt();
      const choice = await promptEvent.userChoice;
      if (choice?.outcome === 'accepted') setInstalled(true);
      setPromptEvent(null);
      return;
    }
    setDialogOpen(true);
  };

  return (
    <>
      <Button variant="outlined" size="small" startIcon={<DownloadIcon />} onClick={handleClick}>
        Instalează aplicația
      </Button>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Instalează SRBCredite</DialogTitle>
        <DialogContent>
          {isIos ? (
            <Typography variant="body2">
              Pe iPhone sau iPad: apasă butonul Share din Safari, apoi alege
              „Adaugă la ecranul principal".
            </Typography>
          ) : (
            <Typography variant="body2">
              Deschide meniul browserului și alege „Instalează aplicația" sau
              „Adaugă la ecranul principal".
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Închide</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
